import useAIConfigs from "@/hooks/useAIConfigs";
import IconArrowBack1 from "@/icons/IconArrowBack1";
import IconArrowBack2 from "@/icons/IconArrowBack2";
import * as React from "react";
import { Link, useParams } from "react-router-dom";
import { AIConfiguration } from "../Messaging/Bots/types";
import LoadingSpinner from "@/components/LoadingSpinner";
interface Props {
  title: string;
  subTitle?: string;
  headerActions?: React.ReactNode;
  children: React.ReactNode;
  backLink?: string;
}

export default function StickyRouteHeader(props: Props) {
  const { id } = useParams();
  const { aiConfigurations, loading } = useAIConfigs();
  const [config, setConfig] = React.useState<AIConfiguration>();


  React.useEffect(() => {
    if (aiConfigurations.length > 0 && id) {
      const config = aiConfigurations.find(
        (config) => config.id === parseInt(id)
      );
      if (config) {
        setConfig(config);
        return;
      }
    }
    setConfig(undefined);
  }, [aiConfigurations, id]);

  if (loading && id && !isNaN(parseInt(id))) {
    return (
      <div className="flex justify-center items-center h-64">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <>
      <div className="sticky top-0 z-50 bg-white border-b border-zinc-200 mb-4">
        <div className="flex items-center justify-between py-3 px-1">
          <div className="text-lg font-medium text-zinc-800 flex flex-row items-center">
            {props.backLink && (
              <span className="mr-2">
                <Link to={props.backLink}>
                  <IconArrowBack2 />
                </Link>
              </span>
            )}
            <div className="flex flex-col">
              <span className="font-semibold text-zinc-800 leading-snug">{config?.name || props.title}</span>
              {props.subTitle && (
                <span className="text-sm font-normal text-zinc-500 dark:text-zinc-300 mt-0.5">
                  {props.subTitle}
                </span>
              )}
            </div>
          </div>
          {props.headerActions && <span>{props.headerActions}</span>}
        </div>
      </div>
      {props.children}
    </>
  );
}
